import React, { useEffect, useState, forwardRef } from "react";
import { withStyles } from '@material-ui/styles';

import {
  List, ListItem, 
  ListItemIcon, ListItemText,
  Card, CardContent
} from '@material-ui/core';

import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import withShowToast from "../../../../../hocs/with_show_toast.js";
import withScrollListener from "../../../../../hocs/with_scroll_listener.js";
import { compose } from 'redux';

import NavigationTabContent from "../../../components/navigation_tab_content.js";

import pageStyles from "../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../base_info_page.js.jsx";

import WebIdFilesUseCase from "../../../../../use_cases/admin/users/users/web_id_files_use_case.js";

const styles = theme => ({
  filesList: {

  }
});


const UserWebIdFilesTab = forwardRef((props, ref) => {

  const { user, classes } = props;
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    WebIdFilesUseCase.execute(user.id)
    .then((result) => {
      const { data: { webidFiles } } = result;
      setFiles(webidFiles)
      setLoading(false);
    })
    .catch((result) => {  
      const { showServerErrorIfNeed } = props;
      setLoading(false);
      showServerErrorIfNeed(result);
    })
  }, [])

  return (
    <NavigationTabContent visible = { props.visible } >
      <Card className = { classes.card }>
        <CardContent>
          <List>
            {
              files.map((file) => {
                return <ListItem key = { file.id }
                                button 
                                component = { "a" } 
                                target = { "_blank" }
                                href = { file.url } >
                  <ListItemIcon>
                    <InsertDriveFileIcon />
                  </ListItemIcon>
                  <ListItemText primary = { file.filename } />
                </ListItem>
              })
            }
          </List>
        </CardContent>
      </Card>
    </NavigationTabContent>
  );
});

export default compose(
  withShowToast,
  withScrollListener,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(UserWebIdFilesTab);
